import React from 'react';
import Icon, { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

export type SVGComponent = React.ComponentType<
  React.PropsWithChildren<CustomIconComponentProps | React.SVGProps<SVGSVGElement>>
>;

type IProps = {
  style?: React.CSSProperties;
  component: unknown;
};

const NavigationIcon: React.FC<React.PropsWithChildren<IProps>> = ({ style, component }) => {
  const defaultStyle = {
    fontSize: 24,
    ...style,
  };
  return <Icon component={component as SVGComponent} style={defaultStyle} />;
};

export default NavigationIcon;
